import { useLocation, useNavigate } from 'react-router-dom';

import { useUpgradeSubscription } from '~/modules/settings/hooks/useUpgradeSubscription';
import analytics from '~/services/analytics';

type HomePageV2HeaderActions = {
  handleUpgradeClick: () => Promise<void>;
  navigateFromHeader: (path: string) => void;
};

export const useHomePageV2HeaderActions = (): HomePageV2HeaderActions => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const fromPath = `${pathname}${search || ''}`;
  const { upgradeSubscription } = useUpgradeSubscription({
    purchaseSource: 'header',
  });

  const handleUpgradeClick = async (): Promise<void> => {
    analytics.trackEvent('subscription - sub promo button click');
    await upgradeSubscription();
  };

  const navigateFromHeader = (path: string): void => {
    navigate(path, {
      state: {
        from: fromPath,
        with_search: false,
      },
    });
  };

  return {
    handleUpgradeClick,
    navigateFromHeader,
  };
};
